import { createSelector } from '@ngrx/store';
import { IFrameReduction, ILoanProfile, ILoanProfileOption, ISimulatorData, ISimulatorModel } from '@partners/api';
import { IRemoteError } from '@partners/errors';
import { IRootState } from '../../../root';
import { ISimulatorState } from './simulator.state';

export class SimulatorSelectors {
  // todo: replace any type state with root state (once defined)
  static readonly simulatorState = (state: IRootState): ISimulatorState => {
    return state.simulator as ISimulatorState;
  };

  static readonly model = createSelector(SimulatorSelectors.simulatorState, (simulator: ISimulatorState) => {
    return simulator.model as ISimulatorModel;
  });

  static readonly data = createSelector(SimulatorSelectors.simulatorState, (simulator: ISimulatorState) => {
    return simulator.data as ISimulatorData;
  });
  static readonly error = createSelector(SimulatorSelectors.simulatorState, (simulator: ISimulatorState) => {
    return simulator?.error as IRemoteError;
  });
  static readonly option = createSelector(SimulatorSelectors.simulatorState, (simulator: ISimulatorState) => {
    return simulator?.profileOption as ILoanProfileOption;
  });
  static readonly loanProfiles = createSelector(SimulatorSelectors.data, (data: ISimulatorData) => {
    return data?.loanProfiles as ILoanProfile[];
  });

  static readonly frameReduction = createSelector(SimulatorSelectors.data, (data: ISimulatorData) => {
    return data.frameReduction as IFrameReduction;
  });
}
